// @ts-nocheck
// Shared card shell for the registration edit page sections: anchor target,
// title/description, dirty indicator, per-section Save button.
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Loader2 } from 'lucide-react';

export default function SectionCard({
  id,
  title,
  description,
  dirty,
  saving,
  onSave,
  hideSave = false,
  children,
}) {
  return (
    <Card id={`section-${id}`} data-section={id} className="scroll-mt-24">
      <CardHeader className="flex flex-row items-start justify-between gap-4 space-y-0">
        <div className="space-y-1">
          <CardTitle className="flex items-center gap-2 text-lg">
            {title}
            {dirty && (
              <span
                className="inline-block h-2 w-2 rounded-full bg-warning"
                title="Unsaved changes"
                aria-label="Unsaved changes"
              />
            )}
          </CardTitle>
          {description ? <CardDescription>{description}</CardDescription> : null}
        </div>
        {!hideSave && (
          <Button size="sm" onClick={onSave} disabled={!dirty || saving}>
            {saving ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : null}
            {saving ? 'Saving…' : dirty ? 'Save' : 'Saved'}
          </Button>
        )}
      </CardHeader>
      <CardContent className="space-y-5">{children}</CardContent>
    </Card>
  );
}
